export default __webpack_public_path__ + "static/media/check-icon.24c2e773.svg";